import { api, ApiError } from '../api';

export interface LoginScreenCallbacks {
  onError: (err: ApiError | Error) => void;
}

export function renderLoginScreen(host: HTMLElement, cb: LoginScreenCallbacks): void {
  const card = document.createElement('section');
  card.className = 'card';

  const h2 = document.createElement('h2');
  h2.textContent = 'Sign in to get started';

  const p = document.createElement('p');
  p.textContent =
    'We use your Microsoft account to write to OneNote. Sign-in opens a Microsoft page in this tab and returns here when it’s done.';

  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'btn btn-primary';
  btn.textContent = 'Sign in with Microsoft';

  const small = document.createElement('p');
  small.className = 'small muted';
  small.textContent = "Your file is deleted from our servers after the import finishes.";

  btn.addEventListener('click', async () => {
    btn.disabled = true;
    btn.textContent = 'Redirecting to Microsoft…';
    try {
      const returnTo = window.location.pathname + window.location.search;
      const safeReturn = returnTo.startsWith('/') && !returnTo.startsWith('//') ? returnTo : '/';
      const url = await api.startLogin(safeReturn);
      window.location.href = url;
    } catch (err) {
      btn.disabled = false;
      btn.textContent = 'Sign in with Microsoft';
      cb.onError(err as Error);
    }
  });

  card.append(h2, p, btn, small);
  host.replaceChildren(card);
}
